import { SCRIPT_IMG, ScriptImage } from "@/components/ScriptImage";

function SubBlock({ title, children }) {
  return (
    <div className="space-y-1">
      <h4
        className="text-[#76232F] text-[17px] md:text-[18px] leading-tight"
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 500,
          letterSpacing: "0.01em",
        }}
      >
        {title}
      </h4>
      <div
        className="text-[15px] md:text-base leading-[1.7] text-[#2C1A1D]/85 space-y-3"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {children}
      </div>
    </div>
  );
}

export default function WeddingDayPanel() {
  return (
    <div
      data-testid="panel-block-wedding-day"
      className="max-w-[680px] mx-auto px-2 md:px-0 pb-16"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      <div className="text-center pt-2">
        <ScriptImage src={SCRIPT_IMG.weddingDay} alt="Wedding Day" />
      </div>
      <p className="text-center italic text-[14px] md:text-[15px] text-[#76232F]/80 mt-3">
        <button
          type="button"
          data-testid="wedding-day-travel-link"
          onClick={() =>
            window.dispatchEvent(
              new CustomEvent("wedding:navigate", { detail: { id: "travel" } })
            )
          }
          className="italic underline underline-offset-4 decoration-[#76232F]/40 hover:decoration-[#76232F] hover:text-[#76232F] transition-colors"
        >
          The Dairy, Ravensbourne
        </button>
      </p>
      <p className="text-center text-[14px] md:text-[15px] uppercase tracking-[0.36em] font-semibold text-[#76232F] mt-8 mb-0">
        October
      </p>
      <div className="mt-2 mb-12 flex justify-center">
        <img
          src={`${process.env.REACT_APP_BACKEND_URL}/api/illustrations/october-calendar.png?v2`}
          alt="October — 30 circled"
          data-testid="wedding-day-calendar"
          className="w-full max-w-[260px] h-auto"
          loading="lazy"
        />
      </div>

      <div className="space-y-12">
        <SubBlock title="Ceremony">
          <p>
            Our vows will be exchanged at The Dairy at three o&rsquo;clock in
            the afternoon.{" "}
            <strong className="font-semibold text-[#2C1A1D]">
              Please plan to arrive by 2:30 to allow time to settle in.
            </strong>{" "}
            The ceremony will be followed by a golden hour,
            reception, and dancing.
          </p>
        </SubBlock>

        <SubBlock title="Dress Code">
          <p>
            The dress code is <strong className="font-semibold">Black Tie</strong>. This
            traditionally means men would wear black tuxedos, however dark
            formal suits are also welcome. For women, please wear
            elegant floor-length dresses or evening gowns.
          </p>
          <p>In keeping with tradition, we kindly ask that guests refrain from wearing shades of white, ivory, or cream.</p>
          <div className="flex justify-center pt-2 pb-2 not-prose">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/illustrations/dresscode.png?v2`}
              alt="Black tie dress code illustration"
              data-testid="wedding-day-dresscode-illustration"
              className="h-[220px] w-auto max-w-full object-contain"
              loading="lazy"
            />
          </div>
          <p>
            For our Filipino family, we encourage you to wear traditional
            attire &mdash; floor-length Filipiniana and Barong Tagalog
            (pi&ntilde;a fabric is fully welcome!)
          </p>
          <div className="flex justify-center items-center gap-6 pt-2 pb-2 not-prose">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/illustrations/barong.png?v3`}
              alt="Barong illustration"
              data-testid="wedding-day-barong-illustration"
              className="h-[160px] w-auto object-contain"
              loading="lazy"
            />
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/illustrations/filipiniana.png?v2`}
              alt="Filipiniana illustration"
              data-testid="wedding-day-filipiniana-illustration"
              className="h-[160px] w-auto object-contain"
              loading="lazy"
            />
          </div>
          <p>
            Weather in Ravensbourne in October sits comfortably between
            15&ndash;26 &deg;C. Fireplace heating will be available indoors
            but please opt to have a light jacket available for the evening.
          </p>
        </SubBlock>

        <SubBlock title="Transportation">
          <p>
            Complimentary shuttles will depart from Toowoomba and Ravensbourne
            before and after the wedding. Please specify this on the RSVP if
            you would like transportation.
          </p>
        </SubBlock>
      </div>
    </div>
  );
}
